<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="none"
        viewBox="0 0 16 16"
        :aria-labelledby="props.ariaLabelledby"
        :aria-hidden="!props.ariaLabelledby"
        role="img"
    >
        <path
            fill="currentColor"
            d="m6.4 10.4.933-.95L5.883 8l1.45-1.45L6.4 5.6 4 8l2.4 2.4Zm3.2 0L12 8 9.6 5.6l-.933.95L10.117 8l-1.45 1.45.933.95ZM3.333 14c-.366 0-.68-.13-.941-.392A1.284 1.284 0 0 1 2 12.667V3.333c0-.366.13-.68.392-.941.26-.261.575-.392.941-.392h9.334c.366 0 .68.13.941.392.261.26.392.575.392.941v9.334c0 .366-.13.68-.392.941a1.284 1.284 0 0 1-.941.392H3.333Zm0-1.333h9.334V3.333H3.333v9.334Z"
        />
    </svg>
</template>

<script setup lang="ts">
type CodeIconProps = {
    ariaLabelledby?: string;
};

const props = defineProps<CodeIconProps>();
</script>
